"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsStructuredSnippetManagement = exports.googleAdsStructuredSnippetManagementArgsSchema = exports.GoogleAdsStructuredSnippetAction = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// ---------- Add Structured Snippet ----------
var googleAdsAddStructuredSnippetInputSchema = zod_1.z
    .object({
    campaignId: zod_1.z
        .string()
        .nullish()
        .describe('The campaign ID to attach the structured snippet to (required if assetGroupId and adGroupId are not provided).'),
    assetGroupId: zod_1.z
        .string()
        .nullish()
        .describe('Optional asset group ID to attach the structured snippet to (for Performance Max campaigns).'),
    adGroupId: zod_1.z
        .string()
        .nullish()
        .describe('Optional ad group ID to attach the structured snippet to (for Search/Display campaigns).'),
    header: zod_1.z
        .enum([
        'Amenities',
        'Brands',
        'Courses',
        'Degree programs',
        'Destinations',
        'Featured Hotels',
        'Insurance coverage',
        'Models',
        'Neighborhoods',
        'Services',
        'Shows',
        'Styles',
        'Types',
    ])
        .describe('The predefined header type for the structured snippet. Choose the header that best describes your list. Common options: "Services" (for service offerings), "Brands" (for product brands), "Types" (for product categories), "Amenities" (for features/benefits).'),
    values: zod_1.z
        .array(zod_1.z.string().min(1).max(25, 'Each value must be 25 characters or less'))
        .min(3, 'Structured snippets require at least 3 values')
        .max(10, 'Structured snippets can have at most 10 values')
        .describe('Array of values to display under the header. CRITICAL: Requires 3-10 values, each with maximum 25 characters (including spaces). Count characters in EACH value BEFORE calling. Examples for "Services": ["Web Design" (10 chars), "SEO Optimization" (16 chars), "Content Marketing" (17 chars)].'),
})
    .describe('Add a structured snippet extension to a Google Ads campaign, asset group, or ad group.');
var googleAdsAddStructuredSnippetArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsAddStructuredSnippetInputSchema);
var googleAdsAddStructuredSnippetResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    structuredSnippetId: zod_1.z.string().describe('The ID of the created structured snippet asset'),
    linkTarget: zod_1.z
        .enum(['campaign', 'assetGroup', 'adGroup'])
        .describe('The type of entity the structured snippet is linked to'),
    message: zod_1.z
        .string()
        .nullish()
        .describe('Additional information about the structured snippet creation'),
});
var googleAdsAddStructuredSnippetResultSchema = googleAdsAddStructuredSnippetResponseSchema;
// ==========================
// Compound Tool: googleAdsStructuredSnippetManagement
// ==========================
exports.GoogleAdsStructuredSnippetAction = zod_1.z.enum(['addStructuredSnippet']);
exports.googleAdsStructuredSnippetManagementArgsSchema = zod_1.z.object({
    action: zod_1.z.discriminatedUnion('name', [
        zod_1.z.object({
            name: zod_1.z.literal('addStructuredSnippet'),
            params: googleAdsAddStructuredSnippetArgsSchema.shape.args,
        }),
    ]),
    emitMode: zod_1.z.literal('single'),
});
var GoogleAdsStructuredSnippetManagementAllResultsSchema = googleAdsAddStructuredSnippetResultSchema;
var googleAdsStructuredSnippetManagementResultSchemas = (0, common_1.defineDynamicSchemas)()({
    dependencies: ['action.name'],
    variants: [
        {
            when: { 'action.name': 'addStructuredSnippet' },
            schema: googleAdsAddStructuredSnippetResultSchema,
        },
    ],
    defaultSchema: GoogleAdsStructuredSnippetManagementAllResultsSchema,
});
exports.googleAdsStructuredSnippetManagement = (0, common_1.createToolMetadata)({
    id: 'googleAdsStructuredSnippetManagement',
    displayName: 'Google Ads Structured Snippet Management',
    displayDescription: 'Add structured snippet extensions to Google Ads campaigns',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsStructuredSnippetManagementArgsSchema,
}, googleAdsStructuredSnippetManagementResultSchemas);
